import { DeleteIcon, EditIcon, InfiniteTable } from '@/components/_common';
import { Space, Divider, Modal } from 'antd';
import { ColumnsType } from 'antd/es/table/interface';
import React from 'react';
import { useIntl } from 'react-intl';
import {
  KitReduced,
  KitsQueryFilters,
} from '@/core/domain/operational/Kits/Kits.types';
import {
  useDeleteKit,
  useListKitReduced,
} from '@/core/domain/operational/Kits/Kits.hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { useDebounce } from '@/hooks';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

interface Props {
  queryParams: KitsQueryFilters;
}

const KitsList: React.FC<Props> = ({ queryParams }) => {
  const intl = useIntl();

  const queryDebounce = useDebounce(queryParams);

  const kitList = useListKitReduced(queryDebounce);
  const kits = flatInfiniteData(kitList.data);

  const { mutateAsync: removeKitMutation } = useDeleteKit();

  const handleDeleteKit = (kit: KitReduced) => {
    Modal.confirm({
      title: 'Confirmação de Remoção',
      content: (
        <p>
          Tem certeza de que deseja remover o seguinte kit?
          <br />
          <br />"<strong>{kit?.description}</strong>"
        </p>
      ),
      onOk: async () => {
        await removeKitMutation(kit.id);
      },
      okType: 'danger',
      okText: 'Remover',
      width: 500,
    });
  };

  const columns: ColumnsType<KitReduced> = [
    {
      key: 'description',
      dataIndex: 'description',
      title: 'Descrição',
      ellipsis: true,
    },
    {
      key: 'action',
      title: intl.formatMessage({ id: 'commons.list.header.action' }),
      fixed: 'right',
      align: 'center',
      width: 80,
      render: (_, row) => (
        <Space>
          <EditIcon
            redirect={`/app/operational/kits/${row.id}`}
            disabled={!hasPermissions([Authorities.KITS_EDIT])}
          />

          <Divider type="vertical" />

          <DeleteIcon
            onClick={() => handleDeleteKit(row)}
            disabled={!hasPermissions([Authorities.KITS_DELETE])}
          />
        </Space>
      ),
    },
  ];

  return (
    <InfiniteTable<KitReduced>
      loading={kitList.isFetching}
      rowKey={(row) => row.id}
      dataSource={kits}
      columns={columns}
      scroll={{ x: true }}
      fetchNextPage={kitList.fetchNextPage}
      hasNextPage={kitList.hasNextPage}
    />
  );
};

export default KitsList;
